// removed by extract-text-webpack-plugin
module.exports = {"row":"Y_cz140AIVOPjciKMNOSk","btnShow":"_3UyZ9exdKAIRSLO2svGfAF"};


//////////////////
// WEBPACK FOOTER
// ./src/components/CountriesList/CountriesList.scss
// module id = 1589
// module chunks = 0